/* @flow */

import * as types from './onboardingActionTypes';
import { patchMembership } from 'src/shared/domain/membership/action/membershipActions';

export function completeOnboarding(eventId: number) {
  return patchMembership(eventId, {
    flags: {
      onboarding_completed: true,
    },
  });
}

export function completeOnboardingOptimistically(membershipId: number) {
  return {
    type: types.COMPLETE_ONBOARDING_OPTIMISTICALLY,
    membershipId,
  };
}
